import React from 'react';
import { NavLink } from 'react-router-dom';

const ConfigNavigation: React.FC = () => {
  return (
    <nav className="bg-white shadow-sm border-b mb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8">
          <NavLink
            to="/config/sessions"
            className={({ isActive }) =>
              `py-4 px-1 border-b-2 font-medium text-sm ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`
            }
          >
            Sessions Utilisateur
          </NavLink>
          
          <NavLink
            to="/config/ponts-bascule"
            className={({ isActive }) =>
              `py-4 px-1 border-b-2 font-medium text-sm ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`
            }
          >
            Ponts Bascule
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default ConfigNavigation;
